import { useRoute } from 'shared/src/hooks/useRoute';

export type MyPageParamList = {
  AddressList: {
    instanceId?: string;
    mode?: 'manage' | 'select';
    /**
     * [web/embedded-web 전용] 선택 결과를 돌려줄 iframe 콜백 이름.
     * 콘텐츠가 `openDeliveryList` 메시지의 `ok_function_name` 으로 올린 값이다.
     */
    okFunctionName?: string;
  };
  AlarmSetting: {
    instanceId?: string;
  };
  Laboratory: {
    instanceId?: string;
  };
  MyPersonalization: {
    instanceId?: string;
    from?: string;
    initialTabIndex?: number;
    productCategorySno?: number;
  };
  PointOfContact: {
    instanceId?: string;
  };
  Setting: {
    instanceId?: string;
  };
  MyInfo: {
    instanceId?: string;
    from?: string;
  };
};

export const useMyPageRoute = <Key extends keyof MyPageParamList>() =>
  useRoute<MyPageParamList, Key>();
